import { useState } from "react";
import axios from "axios";

const Login = () => {
  const [input, setInput] = useState({
    email: "",
    password: ""
  });

  const [msg, setMsg] = useState("");
  const [isError, setIsError] = useState(false);

  const handleChange = (e) => {
    setInput({
      ...input,
      [e.target.name]: e.target.value
    });
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post("http://localhost:4000/api/login", {
        email: input.email,
        password: input.password
      });

      setMsg(response.data.message);
      setIsError(false); // success message
      console.log("Login success", response.data);

      // Example: redirect or save token
      // localStorage.setItem("user", JSON.stringify(response.data.user));
      // navigate('/dashboard');

    } catch (error) {
      console.error("Login error:", error);

      // Show backend error message
      if (error.response && error.response.data && error.response.data.message) {
        setMsg(error.response.data.message);
      } else {
        setMsg("Something went wrong. Please try again.");
      }
      setIsError(true);
    }
  };

  return (
    <div className="container-fluid loginBackground">
      <div className="container">
        <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
          <form className="rounded text-dark glassEffect p-4" onSubmit={handleLogin}>
            <h3 className="mb-4">Login</h3>

            {msg && (
              <div className={`alert ${isError ? "alert-danger" : "alert-success"}`} role="alert">
                {msg}
              </div>
            )}

            <div className="mb-3">
              <label htmlFor="email" className="form-label">Email address</label>
              <input
                type="email"
                className="form-control"
                id="email"
                name="email"
                value={input.email}
                onChange={handleChange}
                placeholder="name@example.com"
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="password" className="form-label">Password</label>
              <input
                type="password"
                className="form-control"
                id="password"
                name="password"
                value={input.password}
                onChange={handleChange}
                placeholder="********"
                required
              />
            </div>

            <div className="text-end">
              <button type="submit" className="btn btn-primary">Login</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
